import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, SearchIcon, HeartIcon, EyeIcon, BrainIcon, CompassIcon, ZapIcon, SunIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function ProductDescriptionSection() {
  const helps = [{
    text: 'entender qué se apagó,',
    icon: LightbulbIcon
  }, {
    text: 'reconocer si aún hay algo que reconstruir,',
    icon: SearchIcon
  }, {
    text: 'ordenar tus emociones sin culpa,',
    icon: HeartIcon
  }, {
    text: 'dejar de negar lo que sientes,',
    icon: EyeIcon
  }, {
    text: 'recuperar tu claridad mental,',
    icon: BrainIcon
  }, {
    text: 'y decidir desde la conciencia, no desde el miedo.',
    icon: CompassIcon
  }];
  const benefits = [{
    title: 'Comprensión del problema',
    desc: 'Vas a entender por qué una relación puede seguir funcionando por fuera mientras por dentro se enfría.'
  }, {
    title: 'Validación emocional',
    desc: 'Vas a dejar de sentir que estás exagerando o pidiendo demasiado.'
  }, {
    title: 'Orden mental',
    desc: 'Vas a poner en palabras lo que sientes para salir de la confusión.'
  }, {
    title: 'Claridad para decidir',
    desc: 'Vas a ver con más honestidad qué todavía puede reconstruirse y qué no puede seguir negándose.'
  }, {
    title: 'Recuperación de tu centro',
    desc: 'Vas a dejar de vivir en automático y empezar a volver a ti.'
  }];
  return <section className="py-8 md:py-12 px-6 bg-[#F0E6EF]" data-id="element-208">
      <div className="max-w-4xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto mb-10" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-211">
            QUÉ ES DESCONEXIÓN EMOCIONAL
          </h2>

          <div className="space-y-4 text-lg text-mutedBrown leading-relaxed" data-id="element-212">
            <p data-id="element-213">
              <strong className="text-warmBrown font-heading text-xl" data-id="element-214">
                DESCONEXIÓN EMOCIONAL
              </strong>{' '}
              es un mapa privado para mujeres emocionalmente agotadas que
              necesitan comprender su relación antes de perderse por completo
              dentro de ella.
            </p>
            <p data-id="element-215">
              Esta guía no fue creada para empujarte al divorcio. Tampoco para
              venderte falsas promesas.
            </p>
            <p data-id="element-216">Fue creada para ayudarte a:</p>

            <ul className="space-y-3 pl-2" data-id="element-217">
              {helps.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-center gap-3" data-id="element-218">
                    <Icon className="w-5 h-5 text-terracotta flex-shrink-0" data-id="element-219" />
                    <span data-id="element-220">{item.text}</span>
                  </li>;
            })}
            </ul>
          </div>

          <div className="mt-8" data-id="element-221">
            <CTAButton text="QUIERO ACCEDER AHORA" icon={<ZapIcon className="w-5 h-5" data-id="element-223" />} data-id="element-222" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-224">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-225">
            LO QUE VAS A LOGRAR CON ESTA GUÍA
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-226">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className={`bg-cream p-6 rounded-xl border border-softGold/20 ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-md md:mx-auto w-full' : ''}`} data-id="element-227">
                <h4 className="text-xl font-bold text-terracotta mb-3 font-heading" data-id="element-228">
                  {benefit.title}
                </h4>
                <p className="text-mutedBrown" data-id="element-229">{benefit.desc}</p>
              </motion.div>)}
          </div>

          <div className="mt-8" data-id="element-230">
            <CTAButton text="QUIERO VOLVER A MÍ" icon={<SunIcon className="w-5 h-5" data-id="element-232" />} data-id="element-231" />
          </div>
        </motion.div>
      </div>
    </section>;
}